import { WebsocketService } from '../../../shared/src/lib/service/websocket.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../shared/src/lib/service/authentification.service';
import { AppStateAi } from './ai.states';
import { DictionnaryService } from '../../../shared/src/lib/service/dictionnary.service';
import * as authActions from '../../../shared/src/lib/store/actions/auth.actions';
import * as userActions from '../../../shared/src/lib/store/actions/user.actions';

@Component({
  selector: 'app-ai',
  templateUrl: './ai.component.html',
  styleUrls: ['./ai.component.scss']
})
export class AiComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private dictionnaryService: DictionnaryService,
    private translateService: TranslateService,
    private store: Store<AppStateAi>,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.setTranslation();
    // this.login()
    // this.setTranslation()
  }

  login() {
    if (this.authenticationService.accessToken
      && this.authenticationService.xBundleRecurring) {
      this.store.dispatch(authActions.loginSuccess(
        {
          payload: {
            access_token: this.authenticationService.accessToken,
            xBundleRecurring: this.authenticationService.xBundleRecurring  
          }
        }
      ));
      this.store.dispatch(userActions.GetUser());
    }
  }

  /**
 * Lancement de la traduction.
 */
  setTranslation() {
    const _lang = localStorage.getItem('language');
    this.translateService.setDefaultLang(_lang);
    this.translateService.use(_lang);
    this.dictionnaryService.getDictionnary2(_lang)
      .subscribe(res => {
        if (res) {
          this.translateService.setTranslation(_lang, res);
        }
      });
  }
}
